
export default function FinalCTA() {
  return (
    <section id="contact" className="py-24 md:py-32 bg-gray-900">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Work Together?
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
          Whether you're a store looking for better products or a producer seeking distribution, let's start the conversation.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            id="store-inquiry"
            href="#store-form"
            className="px-8 py-4 bg-white text-gray-900 text-base font-semibold rounded-md hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Store Inquiry
          </a>
          <a
            id="producer-inquiry"
            href="#producer-form"
            className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-semibold rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Producer Inquiry
          </a>
        </div>
      </div>
    </section>
  );
}
